import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, switchMap, take, tap } from 'rxjs';
import { Notification } from 'app/layout/common/notifications/notifications.types';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService
{
    private _notifications: ReplaySubject<Notification[]> = new ReplaySubject<Notification[]>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for notifications
     */
    get notifications$(): Observable<Notification[]>
    {
        return this._notifications.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all notifications
     */
    getAll(): Observable<Notification[]>
    {
        return this._httpClient.get<Notification[]>('api/notification').pipe(
            tap((notifications) => {
                this._notifications.next(notifications);
            })
        );
    }



    /**
     * Mark notifications as read
     */
    markAsRead(notificationIds: string[]): Observable<any> {
        return this.notifications$.pipe(
            take(1),
            switchMap(notifications => this._httpClient.post<any>('api/notification/mark-as-read',{notificationIds: notificationIds}).pipe(
                map((deletedNotifs: any) => {

                    for(const notif of deletedNotifs){
                        const index = notifications.findIndex(item => item.id === notif.id);

                        // Delete the notification
                        notifications.splice(index, 1);

                        // Update the notifications
                        this._notifications.next(notifications);
                    }


                    return;

                })
            ))
        );
    }
}
